import React from 'react';
import { Field } from 'redux-form';
import { NumberInput, ReferenceInput, required, SelectInput, TextInput } from 'react-admin';
import { createStyles, withStyles } from '@material-ui/core/styles';

const ValidateRequired = required();

const styles = createStyles({
  long_field: {
    width: '70%'
  },
  short_field: {
    width: '30%'
  }
});

type Props = {
  classes: any,
  record: any
};

const SettingsTab = (props: Props) => (
  <div>
    <Field name="name" source="name" component={TextInput} label="Name *" validate={ValidateRequired} className={props.classes.long_field} /><br />
    <Field name="key" source="key" resource="macro_map_keys" component={ReferenceInput} label="Key *" reference="helpers/macro_map_keys" sort={{ field: 'name', order: 'ASC' }} allowEmpty record={props.record}>
      <Field name="key" source="key" label="Key *" component={SelectInput} validate={ValidateRequired} />
    </Field><br />
    <Field name="value" source="value" component={TextInput} label="Value *" validate={ValidateRequired} className={props.classes.long_field} /><br />
    <Field name="mappedValue" source="mappedValue" component={TextInput} label="Mapped Value *" validate={ValidateRequired} className={props.classes.long_field} /><br />
    <Field name="priority" source="priority" component={NumberInput} label="Priority *" validate={ValidateRequired} step={1.0} />
  </div>
);

export default withStyles(styles)(SettingsTab);



// WEBPACK FOOTER //
// ./src/views/Components/MacroMaps/Partials/SettingsTab.tsx